import { validationRules } from '../../utils/validationRules'
import axios from 'axios'

export default {
  name: 'Login',
  props: {
    source: String,
  },
  mounted: function () {
    if (this.$isUserLoggedIn()) {
      this.$router.push('/')
    }
  },
  data: function () {
    return {
      valid: false,
      loading: false,
      email: '',
      password: '',
      validationRules: validationRules,
      loginErrorMsg: ''
    }
  },
  methods: {
    login () {
      if (this.valid) {
        this.loading = true
        this.loginErrorMsg = ''
        const customAxios = axios.create()
        customAxios.post(`${this.$commonPath}login`, {
          grant_type: 'password',
          client_id: 1,
          client_secret: 123456,
          request_from: 'clientApp',
          username: this.email,
          password: this.password
        }).then((res) => {
          this.loading = false
          localStorage.setItem(process.env.VUE_APP_LSACCESSTOKENKEY, res.data.access_token)
          localStorage.setItem(process.env.VUE_APP_LSUSERDATAKEY, JSON.stringify(res.data.user_data))
          localStorage.setItem(process.env.VUE_APP_LSREFRESHTOKENKEY, res.data.refresh_token)
          this.$router.push('/')
        }).catch((error) => {
          this.loading = false
          this.loginErrorMsg = error.response.data.error_description
          this.$userLoggedOut()
        })
      } else {
        this.$refs.loginForm.validate()
      }
    }
  }
}
